<template>
	<li class="uk-open">
		<button type="button" class="uk-accordion-title">1. Bed Color</button>
		<div class="uk-accordion-content">
			<div v-if="cabinetBedColor" class="color-header">
				Color: <strong>{{ cabinetBedColor.name }}</strong>
				<span v-if="currentUpcharge > 0">(+{{ currentUpcharge | currency }})</span>
			</div>
			<div class="wood-type-container section-overflow qb-finishes-grid" tabindex="0" role="region" aria-label="Cabinet bed colors">
				<div class="uk-child-width-1-3@s uk-grid-small uk-child-width-1-2" uk-grid>
					<div v-for="color in cabinetBed.colors" :key="'color_option_'+color.id">
						<button type="button" class="wood-type" :class="{'selected' : isActive(color)}" role="radio" :aria-checked="isActive(color) ? 'true' : 'false'" :aria-label="`${color.name} cabinet bed color`" @click.prevent="onClick(color)">
							<img :src="imgStyle(color)" alt="">
							<p class="name">{{ color.name }}</p>
						</button>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "CabinetBedColor",

	props: {
		dataFailure: {
			type: Boolean,
			default: false
		}
	},
	components: {},
	data() {
		return {
			selectedSizeId: 0,
			selectedColorId: null
		}
	},
	mounted() {
	},
	methods: {
		imgStyle(finish) {
			if(finish && finish.image){
				return `${finish.image.webPath}/80`;
			}
			return '';
		},
		setSize(sizeId) {
			this.selectedSizeId = sizeId;
		},
		/**
		 * user clicked on one of the popular finishes
		 * @param  {[type]} selectedColor [description]
		 * @return {[type]}        [description]
		 */
		onClick(selectedColor) {
			this.$store.commit('setSelectedCabinetBedColor', selectedColor);

			// Notify carousel of color change so the gallery scrolls to the
			// matching image (via data-color-slug). Cabinet beds have a single
			// color name rather than a wood+finish pair, so we pass it as
			// `finish` and leave `wood` empty.
			window.dispatchEvent(new CustomEvent('bedBuilderColorChange', {
				detail: {
					wood: '',
					finish: selectedColor ? selectedColor.name : '',
				}
			}));
		},
		/**
		 * Determines if the provided color is currently active based on its ID.
		 *
		 * @param {Object} color - The color object to be checked.
		 * @param {number} color.id - The unique identifier of the color.
		 * @return {boolean} Returns `true` if the provided color is active, otherwise `false`.
		 */
		isActive(color) {
			if (this.cabinetBedColor == null) return false;
			return this.cabinetBedColor.id == color.id;
		},
		calculateUpcharge(color) {
			let upcharge = this.tryFloat(color.price);
			let currentUpcharge = this.tryFloat(this.priceTotals.color_upcharge);
			let priceChange = upcharge - currentUpcharge;
			return priceChange;
		}
	},
	computed: {
		...mapState({
			cabinetBed: state => state.cabinetBed,
			cabinetBedColor: state => state.cabinetBedColor,
			priceTotals: state => state.totals,
			useDiscounts: state => state.useDiscounts
		}),
		someColorsHavePrices() {
			let hasPrices = false;
			for(let i = 0; i < this.cabinetBed.colors.length; ++i){
				let color = this.cabinetBed.colors[i];
				if(this.tryFloat(color.price) > 0){
					hasPrices = true;
					break;
				}
			}
			return hasPrices;
		},
		currentUpcharge() {
			if(!this.cabinetBedColor || !this.cabinetBedColor.price) return 0;
			return this.tryFloat(this.cabinetBedColor.price);
		}
	},
	watch: {
		
	}
}
</script>
<style scoped>
.color-header {
	font-size: 1.6rem;
	margin-bottom: 0;
	padding-top: 10px;
	color: #333;
}
.color-header span {
	color: #666;
}
.qb-finishes-grid {
	max-height: 180px;
	overflow-y: auto;
}
.wood-type {
	text-align: center;
	border: none;
	background: transparent;
	max-width: 112px;
}
.wood-type img {
	width: 100%;
	height: auto;
	aspect-ratio: 1;
	object-fit: cover;
	display: block;
}
.finish-name {
	font-size: 0.8rem;
	font-weight: 500;
	margin: 4px 0 0;
	line-height: 1.2;
}
.wood-name {
	font-size: 0.65rem;
	color: #757575;
	margin: 0;
	line-height: 1.2;
}
</style>